'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import StatusBadge from '@/components/ui/StatusBadge';
import Icon from '@/components/ui/AppIcon';

const campaigns = [
{
  id: 'camp-001',
  name: 'Galaxy S26 Launch',
  objective: 'Lancement produit',
  status: 'in-progress' as const,
  budget: 2000000,
  spent: 1200000,
  creators: 4,
  creatorsConfirmed: 3,
  startDate: '10 Aoû 2026',
  endDate: '31 Aoû 2026',
  reach: '4.2M',
  engagementAvg: '7.8%',
  progress: 62,
  creatorAvatars: [
  { id: 'av-001', src: "https://img.rocket.new/generatedImages/rocket_gen_img_11d1826d1-1763301150073.png", alt: 'Creator 1 avatar' },
  { id: 'av-002', src: "https://img.rocket.new/generatedImages/rocket_gen_img_11d1826d1-1763301150073.png", alt: 'Creator 2 avatar' },
  { id: 'av-003', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9c7379d-1772726901691.png", alt: 'Creator 3 avatar' }]

},
{
  id: 'camp-002',
  name: 'Ramadan Campaign 2026',
  objective: 'Notoriété de marque',
  status: 'completed' as const,
  budget: 1500000,
  spent: 1480000,
  creators: 6,
  creatorsConfirmed: 6,
  startDate: '1 Mar 2026',
  endDate: '10 Avr 2026',
  reach: '8.7M',
  engagementAvg: '9.1%',
  progress: 100,
  creatorAvatars: [
  { id: 'av-004', src: "https://img.rocket.new/generatedImages/rocket_gen_img_174bb4344-1767118146780.png", alt: 'Creator 4 avatar' },
  { id: 'av-005', src: "https://img.rocket.new/generatedImages/rocket_gen_img_174bb4344-1767118146780.png", alt: 'Creator 5 avatar' }]

},
{
  id: 'camp-003',
  name: 'Back to School 2026',
  objective: 'Drive to sales',
  status: 'draft' as const,
  budget: 800000,
  spent: 0,
  creators: 3,
  creatorsConfirmed: 0,
  startDate: '1 Sep 2026',
  endDate: '20 Sep 2026',
  reach: '—',
  engagementAvg: '—',
  progress: 0,
  creatorAvatars: []
}];


export default function ActiveCampaigns() {
  const [expandedId, setExpandedId] = useState<string | null>('camp-001');

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-700 text-foreground">Campagnes</h2>
        <Link href="/campaign-builder" className="text-sm font-500 text-primary hover:text-primary/80 transition-colors">
          + Nouvelle campagne
        </Link>
      </div>
      <div className="space-y-3">
        {campaigns.map((camp) =>
        <div key={camp.id} className="bg-card border border-border rounded-xl overflow-hidden">
            <button
            className="w-full flex items-center gap-4 p-5 text-left hover:bg-muted/30 transition-all"
            onClick={() => setExpandedId(expandedId === camp.id ? null : camp.id)}>
            
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="text-sm font-700 text-foreground">{camp.name}</h3>
                  <StatusBadge variant={camp.status} size="sm" />
                </div>
                <p className="text-xs text-muted-foreground">{camp.objective} · {camp.startDate} → {camp.endDate}</p>
              </div>

              <div className="hidden sm:flex items-center gap-4">
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">Budget</p>
                  <p className="text-sm font-700 text-foreground font-mono">{(camp.budget / 1000).toFixed(0)}K DA</p>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">Créateurs</p>
                  <p className="text-sm font-700 text-foreground font-mono">{camp.creatorsConfirmed}/{camp.creators}</p>
                </div>
                <div className="flex -space-x-2">
                  {camp.creatorAvatars.map((av) =>
                <div key={av.id} className="w-8 h-8 rounded-full overflow-hidden border-2 border-card">
                      <AppImage src={av.src} alt={av.alt} width={32} height={32} className="w-full h-full object-cover" />
                    </div>
                )}
                </div>
              </div>

              <Icon
              name={expandedId === camp.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
              size={16}
              className="text-muted-foreground flex-shrink-0" />
            
            </button>

            {expandedId === camp.id &&
          <div className="px-5 pb-5 border-t border-border animate-fade-in">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
                  <div>
                    <p className="text-xs text-muted-foreground">Budget dépensé</p>
                    <p className="text-sm font-700 font-mono text-foreground">{(camp.spent / 1000).toFixed(0)}K / {(camp.budget / 1000).toFixed(0)}K DA</p>
                    <div className="mt-1 h-1.5 bg-border rounded-full overflow-hidden">
                      <div className="h-full bg-primary rounded-full" style={{ width: `${camp.budget > 0 ? camp.spent / camp.budget * 100 : 0}%` }} />
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Reach estimé</p>
                    <p className="text-sm font-700 font-mono text-foreground">{camp.reach}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Engagement moyen</p>
                    <p className="text-sm font-700 font-mono text-positive">{camp.engagementAvg}</p>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">Progression</p>
                    <p className="text-sm font-700 font-mono text-foreground">{camp.progress}%</p>
                    <div className="mt-1 h-1.5 bg-border rounded-full overflow-hidden">
                      <div className="h-full bg-positive rounded-full" style={{ width: `${camp.progress}%` }} />
                    </div>
                  </div>
                </div>
              </div>
          }
          </div>
        )}
      </div>
    </div>);

}